module.exports = __webpack_public_path__ + "static/img/zhengxiaoyue.d1828f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/haibao_vx/zhengxiaoyue.png
// module id = Clfc
// module chunks = 0